import { render, staticRenderFns } from "./Treemap.vue?vue&type=template&id=b3428398&scoped=true&"
import script from "./Treemap.vue?vue&type=script&lang=js&"
export * from "./Treemap.vue?vue&type=script&lang=js&"
import style0 from "./Treemap.vue?vue&type=style&index=0&id=b3428398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3428398",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
